import { useState } from 'react';
import { FormControl, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import { FormLabel } from '@/components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

/**
 * Service Category Description field. Optional single-line text field —
 * the old page called it "Description" but used a plain single-line Input,
 * so NameField is used here rather than TextAreaField.
 */
const ServiceCategoryDescriptionField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isInvalid={!!errors.description && touched.description}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Description
                </FormLabel>
                <Field
                    name="description"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Enter a description"
                            label="Description"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="e.g. Answer and move calls seamlessly between devices."
                        ariaLabel="service-category-description-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.description}</FieldError>
        </FormControl>
    );
};

export default ServiceCategoryDescriptionField;
